import React, { useContext, useEffect, useState } from "react"
import AwesomeSlider from "react-awesome-slider"

import "react-awesome-slider/dist/styles.css"
import Hero from "../assets/image/heroimg.svg"
import ProductCard from "../components/ProductCard"
import styled from "styled-components"
import TopSellerCard from "../components/TopSellerCard"
import Footer from "../components/Footer"
import { Link, useNavigate } from "react-router-dom"
import ContactForm from "../components/ContactForm"
import {  query, collection, setDoc, doc, onSnapshot, getDoc } from "firebase/firestore"
import { db, useAuth } from "../firebase-config"
import { toast, ToastContainer } from "react-toastify"
import { Oval } from "react-loader-spinner"
// import { v4 as uuidv4 } from 'uuid';

// import sendemail from 'sendemail'
import {UserContext} from '../context/UserContextProvider'
import { ProductDetailContext } from "../context/ProductDetailsProvider"

const Home = () => {
  const navigate = useNavigate()
  const currentUser = useAuth()
  const [productListArr, setProductListArr] = useState([])
  const [isLiked, setIsLiked] = useState(false)
  const [loader, setLoader] = useState(false)
  const [contactFormData, setContactFormData] = useState({
    name: "",
    email: "",
    message: "",
  })

  const [contactFormPrg, setContactFormPrg] = useState("Send Now")
  const topSellerData = [
    {
      fullname: "Leslie Alexander",
    },
    {
      fullname: "ffsie Alexander",
    },
    {
      fullname: "Courtney Henry",
    },
    {
      fullname: "Sounst Henry",
    },
  ]


  const {handleLoggedInUser} = useContext(UserContext)
  const productContext = useContext(ProductDetailContext)

  // fetching products service

  const fetchProducts = async () => {
    try {
      setLoader(true)
      const q = query(collection(db, "products"))
      // const querySnapshot = await getDocs(q)
      onSnapshot(q, querySnapshot => {
        setProductListArr(
          querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
        )
      })
      setLoader(false)
    } catch (error) {
      setLoader(false)
      console.error(error)
    }

    return
  }

  const fetchProfileDetails = async () => {
    const profileRef = doc(db, "users", currentUser?.uid)
    const resp = await getDoc(profileRef)
    if (resp.exists()) {
      handleLoggedInUser(resp.data())
    }
  }



  const handleAddToWishlist = async (e, item, index) => {
    e.stopPropagation()
    if(isLiked){
      setIsLiked(null)

    }else{
      setIsLiked(index)
      
    }
    console.log(item)
    console.log(productListArr)
    let filteredWishlist = []
    console.log(currentUser.uid)
    console.log(item.wishlistedUser?.includes(currentUser.uid))
    if (item.wishlistedUser?.includes(currentUser.uid)) {
      setIsLiked(false)
      let indexOfitem = item.wishlistedUser.findIndex(
        user => user === currentUser.uid
      )
      filteredWishlist = [...item.wishlistedUser]
      filteredWishlist.splice(indexOfitem, 1)
      console.log(filteredWishlist)
      
      try {
        await setDoc(
          doc(db, "products", item.id),
          {
            wishlistedUser: filteredWishlist,
          },
          { merge: true }
        )
        toast.success("Remove from wishlist")
      } catch (error) {
        console.log(error)
      }
    } else {
      // let alreadyWishlistedUser = [...item.wishlistedUser]
      try {
        console.log('in else block')
        await setDoc(doc(db, "products", item.id),{
            wishlistedUser: [currentUser.uid],
          },{ merge: true })
        toast.success("Added to wishlist")
      } catch (error) {
        console.log(error)
      }
      
    }

    // let tempArr = [currentUser.uid]
    // try {
    //   await setDoc(
    //     doc(db, "products", item.id),
    //     {
    //       wishlistedUser: tempArr,
    //     },
    //     { merge: true }
    //   )
    //   toast.success("Added to wishlist")
    // } catch (error) {
    //   console.log(error)
    // }
  }


  useEffect(() => {
    productContext.handleData({})
    productContext.handleDocId('')
    productContext.handleUser2Id('')
    const unsub = localStorage.getItem("Auth Token")
    fetchProducts()
    // fetchCategories()
    if (unsub) {
      navigate("/")
    }
    return unsub
  }, [])

  useEffect(() => {
    if(currentUser?.uid){
      fetchProfileDetails()
    }
  }, [currentUser?.uid])
  
 
  

  return (
    <>
      <ToastContainer limit={1} autoClose={500} />
      <SliderContainer>
        <AwesomeSlider 
          customContent={<button>Explore</button>}
          bullets={false} className="sliderStyle" >
          <div>
            <img style={{ width: "100%" }} src={Hero} alt="" />
          </div>
          <div>
            <img style={{ width: "100%" }} src={Hero} alt="" />
          </div>
        </AwesomeSlider>
      </SliderContainer>
      {loader ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Oval color={"#fafafa"} secondaryColor={"#dc1d13"} width={"30px"} />
        </div>
      ) : (
        <>
          <ProductsSliderContainer>
            <SliderOption>
              <label className="slider_title">Products</label>
              <ViewBtn to={`/productlist/0`}>View All</ViewBtn>
            </SliderOption>
            <SliderList>
              {productListArr.map((item, index) => {
                return (
                  <ProductCard
                    key={index}
                    product={item?.productDetails}
                    linkTo={`/productdetail/:${item.id}`}
                    productImage={item.productPhoto}
                    productPrice={item.productDetails?.originalPrice}
                    sellerName={""}
                    handleHeartIcon={e => handleAddToWishlist(e, item, index)}
                    isLiked={item.wishlistedUser?.includes(currentUser?.uid) ? true: false}
                    productName={item.productDetails?.productName}
                    setWidth={"10rem"}
                    setHeight={"385px"}
                    imgHeight={"234px"}
                    imgWidth={"10rem"}
                  />
                )
              })}
            </SliderList>
          </ProductsSliderContainer>
          {/* second slider */}
          <ProductsSliderContainer>
            <SliderOption>
              <label className="slider_title">New Products</label>
              <ViewBtn to={`/productlist/0`}>View All</ViewBtn>
            </SliderOption>

            <SliderList>
              {productListArr.map((item, index) => {
                return (
                  <ProductCard
                    key={index}
                    product={item?.productDetails}
                    linkTo={`productdetail/:${item.id}`}
                    productImage={item.productPhoto}
                    productPrice={item.productDetails?.originalPrice}
                    sellerName={""}
                    handleHeartIcon={e =>
                      handleAddToWishlist(
                        e,
                        item.productDetails?.productId,
                        item.id,
                        index
                      )
                    }
                    isLiked={item.wishlistedUser?.includes(currentUser?.uid) || isLiked === index ? true: false}
                    productName={item.productDetails?.productName}
                    setWidth={"15rem"}
                    setHeight={"385px"}
                    imgHeight={"565px"}
                    imgWidth={"15rem"}
                  />
                )
              })}
            </SliderList>
          </ProductsSliderContainer>
          <BannerImageCont>
            <img
              src="https://images.unsplash.com/photo-1599282176284-306385684d42?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8"
              alt=""
            />
          </BannerImageCont>
         
          <EventContainer>
            <label>Events</label>
            <EventCardCont>
              <TopSellerCard
                key={1}
                title={"Top Seller of the week"}
                btnLabel={"View"}
                noOfGem={10}
                item={topSellerData}
              />
              <TopSellerCard
                key={2}
                title={"Top Seller of the week"}
                btnLabel={"View"}
                noOfGem={10}
                item={topSellerData}
              />
            </EventCardCont>
          </EventContainer>
        </>
      )}

      <ContactForm
        action="https://formsubmit.co/aurore.martinet@g2c.store"
        emailVal={contactFormData.email}
        nameVal={contactFormData.name}
        messageVal={contactFormData.message}
        handleEmailChange={e =>
          setContactFormData({ ...contactFormData, email: e.target.value })
        }
        handleNameChange={e =>
          setContactFormData({ ...contactFormData, name: e.target.value })
        }
        handleMessageVal={e =>
          setContactFormData({ ...contactFormData, message: e.target.value })
        }
        // handleOnSend={handleContactForm}
        sendBtnLabel={contactFormPrg}
      />
      <Footer />
    </>
  )
}

export default Home

const SliderContainer = styled.div`
  display: flex;

  .sliderStyle {
    height: 40rem;

    @media screen and (max-width: 768px) {
      height: 10rem;
    }
  }
`

const ProductsSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0rem 2rem;
  margin: 2rem 0rem;
  .sliderStyle {
    height: 20vh;
  }
`

const SliderOption = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  .slider_title {
    font-size: 1.5rem;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
  }
`

const SliderList = styled.div`
  display: flex;
  margin-top: 1rem;
  overflow-x: auto;
  ::-webkit-scrollbar {
    width: 0px;
  }
`

const ViewBtn = styled(Link)`
  background: none;
  border: none;
  font-family: Montserrat;
  text-decoration: none;
  font-style: normal;
  font-weight: normal;
  font-size: 0.8rem;
  text-align: right;
  color: #747178;
  cursor: pointer;
`
const BannerImageCont = styled.div`
  display: flex;

  img {
    height: 60vh;
    width: 100%;
    object-fit: cover;
  }
`
const EventContainer = styled.div`
  display: flex;
  margin: 0rem 2rem;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin: 0;
    align-items: center;
  }
  label {
    font-size: 2rem;
    font-family: Montserrat;
    font-weight: bold;
    letter-spacing: 0.4;
  }
`
const EventCardCont = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`
